import React, { useEffect, useRef, useState } from 'react'
import { MdNotificationsActive, MdNotificationsOff } from 'react-icons/md'
import { FiBell, FiUserMinus } from 'react-icons/fi'
import { useDispatch, useSelector } from 'react-redux'
import * as normalActions from '../store/actions'
import { subscribeAndStore } from './noti'
import { useAuthGate } from './authPrompt'
import './subscribeControl.css'

const SubscribeControl = ({ leaderId, email, hidden }) => {
  const dispatch = useDispatch()
  const { requireAuth, promptEl } = useAuthGate()
  const wrapRef = useRef(null)
  const userid = useSelector(state => state.authReduse.id)
  const follow = useSelector(state => (state.followReduse.follow || []).find(item =>
    String(item.userid) === String(leaderId) || String(item.id) === String(leaderId)
  ))
  const subscribed = !!follow
  const notifyAll = !!follow?.notifyAll
  const [open, setOpen] = useState(false)
  const [ring, setRing] = useState(false)

  useEffect(() => {
    if (!open) return undefined
    const onKey = (event) => {
      if (event.key === 'Escape') setOpen(false)
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open])

  if (hidden || !leaderId || String(leaderId) === String(userid)) return promptEl || null

  const save = (options) => dispatch(normalActions.set_follow(leaderId, { ...options, email }))

  const handleSubscribe = async () => {
    if (!requireAuth()) return
    if (!subscribed) {
      await save({ notify: false })
      setOpen(true)
      return
    }
    setOpen(prev => !prev)
  }

  const chooseNone = async () => {
    if (!requireAuth()) return
    await save({ notify: false })
    setOpen(false)
  }

  const chooseAll = async () => {
    if (!requireAuth()) return
    await save({ notify: true })
    setRing(true)
    setTimeout(() => setRing(false), 700)
    if (userid) subscribeAndStore(userid).catch(() => {})
    setOpen(false)
  }

  const chooseUnsub = async () => {
    if (!requireAuth()) return
    await save({ unsubscribe: true })
    setOpen(false)
  }

  return (
    <>
      {promptEl}
      <div className={`subscribeControl${subscribed ? ' isSubbed' : ''}`} ref={wrapRef}>
        <button
          type="button"
          className={`subscribeControl__cta${subscribed ? ' isOn' : ''}`}
          onClick={handleSubscribe}
          aria-expanded={open}
        >
          <span className="subscribeControl__label">{subscribed ? 'Subscribed' : 'Subscribe'}</span>
        </button>
        <button
          type="button"
          className={`subscribeControl__bell${subscribed ? ' isOn' : ''}${notifyAll ? ' isNotify' : ''}${ring ? ' isRing' : ''}`}
          onClick={handleSubscribe}
          aria-label="Notification settings"
          tabIndex={subscribed ? 0 : -1}
        >
          {notifyAll ? <MdNotificationsActive /> : <FiBell />}
        </button>
      </div>
      <div className={`subscribeMenuScrim${open ? ' isOpen' : ''}`} onClick={() => setOpen(false)} />
      <div className={`subscribeMenu${open ? ' isOpen' : ''}`} role="menu">
        <div className="subscribeMenu__handle" />
        <p className="subscribeMenu__title">Notifications</p>
        <button type="button" className={!notifyAll && subscribed ? 'isActive' : ''} onClick={chooseNone}>
          <MdNotificationsOff />
          <span>
            <strong>Subscribed only</strong>
            <em>No push for new videos</em>
          </span>
        </button>
        <button type="button" className={notifyAll ? 'isActive' : ''} onClick={chooseAll}>
          <MdNotificationsActive />
          <span>
            <strong>All notifications</strong>
            <em>Push for every video they post</em>
          </span>
        </button>
        <button type="button" className="subscribeMenu__unsub" onClick={chooseUnsub}>
          <FiUserMinus />
          <span>
            <strong>Unsubscribe</strong>
            <em>Stop following this channel</em>
          </span>
        </button>
      </div>
    </>
  )
}

export default SubscribeControl
